import { render, staticRenderFns } from "./CustomerMatchResults.vue?vue&type=template&id=7a381aba"
import script from "./CustomerMatchResults.vue?vue&type=script&lang=ts"
export * from "./CustomerMatchResults.vue?vue&type=script&lang=ts"
import style0 from "./CustomerMatchResults.vue?vue&type=style&index=0&id=7a381aba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports